import React from 'react';
import { Route, Routes } from 'react-router-dom';
import List from './pages/List';
import Edit from './pages/Edit';

function Staff() {
    return (
        <Routes>
            <Route
                index
                element={<List />}
            />
            <Route
                path="/edit"
                element={<Edit />}
            />
        </Routes>
    );
}

export default Staff;
